import React, { useContext, useEffect, useState } from 'react';

import Markup from '../../markup';
import BuilderContext from '../../builder/hooks/context';
import useShareService from '../../builder/hooks/useShareService';
import copy from 'copy-to-clipboard';
import { trackShareBuild } from '../../utils/Analytics';

function Share() {
  const { builder } = useContext(BuilderContext);
  const { encode } = useShareService();
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [saveLinkError, setSaveLinkError] = useState("");
  const [preloader, setPreloader] = useState(false);
  const [shareImage, setShareImage] = useState("")

  useEffect(() => {
     builder?.updateCameras({width:200, height:250},["front"],(cameraList) => {
      setShareImage(cameraList?.front)
    })
  },[builder?.controller])


  const encodedLongLink = encode(builder);

  const getFullUrl = (shortLink) => {
    const params = new URLSearchParams();
    params.append('share', shortLink);
  
    return `${window.location.origin}${window.location.pathname}?${params}`;
  }

  const showRequestError = () => {
    setSaveLinkError("Sorry, an error occured, please try again later");
    setTimeout(() => setSaveLinkError(""), 3000);
  }

  const makeRequest = async(action) => {
    try{
      setPreloader(true);
      const shortLink = await window["setShareLink"](encodedLongLink);
      action(getFullUrl(shortLink))
    }catch(e){ showRequestError()}
    
    setPreloader(false)
  }
  

  const openTwitter = () => !preloader && makeRequest((url:string) => {
    window.open(`https://twitter.com/share?url=${url}`, 'twitter-popup', 'height=350,width=600');
    trackShareBuild('Twitter');
  });
  
  const openFacebook = () => !preloader && makeRequest((url:string) => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'facebook-popup', 'height=350,width=600');
    trackShareBuild('Facebook');
  });
  
  const copyLink = () => !preloader && makeRequest((url:string) => {
    copy(url);
    setIsLinkCopied(true);
    trackShareBuild('Link');
    setTimeout(() => setIsLinkCopied(false), 3000);
  });

  return (
    <>
      <Markup.Global.Share.Container>
        <Markup.Global.Share.RenderContainer image={shareImage} />
         <Markup.Global.Share.ContentContainer preloader={preloader || builder.imagesData.activeUploadsCounter}>
          {isLinkCopied && <Markup.Global.Share.Title>Your link was successfully copied!</Markup.Global.Share.Title> }

          {saveLinkError && <Markup.Global.Share.Title>{saveLinkError}</Markup.Global.Share.Title>}
          
          {(!isLinkCopied && !saveLinkError) && 
            <>
              <Markup.Global.Share.Title>Share your design</Markup.Global.Share.Title>
              <Markup.Global.Share.ShareIconContainer>
              <Markup.Global.Share.ShareIconFacebook onClick={openFacebook} />
              {/*<Markup.Global.Share.ShareIconInstagram />*/}
              <Markup.Global.Share.ShareIconTwitter onClick={openTwitter} />
              <Markup.Global.Share.ShareIconLink onClick={copyLink} />
              </Markup.Global.Share.ShareIconContainer>
            </>
          }
        </Markup.Global.Share.ContentContainer>
      </Markup.Global.Share.Container>
    </>
  );
}


export default React.memo(Share);

